<template>
    <div>
        <div id="preview" class="preview-detail" style="width: 520px;">
            <div class="preview-bar">
                <button class="prev-button" @click="prev" v-text="prevText">上一周</button>
                <button class="next-button" @click="next" v-text="nextText">下一周</button>
                <button id="prevClose" class="prev-close" @click="closeBtn">关闭</button>
            </div>
            <div class="preview-plan-detail">
                <PlanView :planData=planData v-if="planData"></PlanView>
                <div v-if="!planData" v-text="emptyMsg" style="text-align: center;padding: 20px 0 0 0;font-size: 18px; font-weight: bold;">

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import PlanView from '@/apps/plan/sub_components/plan_detail.vue'
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        name: "right_month_view",
        components: {
            PlanView
        },
        props: {
            plan_Type: {
                default: null,
                type: String
            },
            dateValue: {
                default: null,
                type: String
            }
        },
        data: function () {
            return {
                planData: null,
                prevText: '上一月',
                nextText: '下一月',
                quarterArray: ["01", "04", "07", "10"],
                quarterArray2: [1, 4, 7, 10],
                startDate: '',
                emptyMsg: ''
            }
        },
        methods: {
            ...mapActions({}),
            prev() {
                if (this.plan_Type == 'week') {
                    this.startDate = new Date(this.getBeforeDate(this.startDate, 7))
                }
                if (this.plan_Type == 'quarter') {
                    let tempM = this.startDate.getMonth() + 1;
                    let tempY = this.startDate.getFullYear();
                    tempM = tempM < 10 ? ('0' + tempM) : (''+tempM);
                    let tempIdx = this.quarterArray.indexOf(tempM);
                    if (tempIdx == 0) {
                        tempY = tempY - 1;
                        tempM = this.quarterArray[3];
                    } else tempM = this.quarterArray[tempIdx - 1];
                    this.startDate = new Date(tempY + '-' + tempM + '-01');
                }
                if (this.plan_Type == 'month') {
                    let tempM = this.startDate.getMonth();
                    let tempY = this.startDate.getFullYear();
                    if (tempM==0){
                         tempM=12;
                        tempY=tempY-1;
                    }
                    else tempM = tempM < 10 ? ('0' + tempM) : tempM;
                    this.startDate = new Date(tempY + '-' + tempM + '-01');
                }
            },
            next() {
            if (this.plan_Type == 'week') {
                    this.startDate = new Date(this.getBeforeDate(this.startDate, -7))
                }
                if (this.plan_Type == 'quarter') {
                    let tempM = this.startDate.getMonth() + 1;
                    let tempY = this.startDate.getFullYear();
                    tempM = tempM < 10 ? ('0' + tempM) : (''+tempM);
                    let tempIdx = this.quarterArray.indexOf(tempM);
                    if (tempIdx == 3) {
                        tempY = tempY + 1;
                        tempM = this.quarterArray[0];
                    } else tempM = this.quarterArray[tempIdx + 1];
                    this.startDate = new Date(tempY + '-' + tempM + '-01');
                }
                if (this.plan_Type == 'month') {
                    let tempM = this.startDate.getMonth()+2;
                    let tempY = this.startDate.getFullYear();
                    if (tempM==13){
                        tempM=1;
                        tempY=tempY+1;
                    }
                    tempM = tempM < 10 ? ('0' + tempM) : tempM;
                    this.startDate = new Date(tempY + '-' + tempM + '-01');
                }
            },
            closeBtn() {
                this.$emit('close');
            },
            getBeforeDate: function (theDate, number) {
                const num = number;
                const date = new Date(theDate);
                let year = date.getFullYear();
                let mon = date.getMonth() + 1;
                let day = date.getDate();
                if (day <= num) {
                    if (mon > 1) {
                        mon = mon - 1;
                    } else {
                        year = year - 1;
                        mon = 12;
                    }
                }
                date.setDate(date.getDate() - num);
                year = date.getFullYear();
                mon = date.getMonth() + 1;
                day = date.getDate();
                const s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day);
                return s;
            },
            getPlanData() {
                let p=[]
                for (var i = 0; i < this.my_plans.length; i++) {
                    if (this.plan_Type == 'month') {
                        if (this.my_plans[i].plan_type === "month" && (new Date(this.my_plans[i].open_time)).getFullYear() == this.startDate.getFullYear() && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) == (this.startDate.getMonth()+1)) {
                            p.push(this.my_plans[i])
                            break
                        }
                        this.emptyMsg =this.startDate.getFullYear()+'年'+(this.startDate.getMonth()+1) +'月没有计划内容'
                    }
                    if (this.plan_Type == 'week') {
                        if (this.my_plans[i].plan_type === "week" && (new Date(this.my_plans[i].open_time)).getFullYear() == this.startDate.getFullYear() && (new Date(this.my_plans[i].open_time)).getMonth() == this.startDate.getMonth() && (new Date(this.my_plans[i].open_time)).getDate() == this.startDate.getDate()) {
                            p.push(this.my_plans[i])
                            break
                        }
                        this.emptyMsg =this.startDate.getFullYear()+'年第'+this.getWeek(this.startDate)+ '周没有计划内容'
                    }
                    if (this.plan_Type == 'quarter') {
                        if (this.my_plans[i].plan_type === "quarter" && (new Date(this.my_plans[i].open_time)).getFullYear() == this.startDate.getFullYear() && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) == (this.startDate.getMonth() + 1)) {
                            p.push(this.my_plans[i])
                            break
                        }
                        this.emptyMsg =this.startDate.getFullYear()+'年第'+(this.quarterArray2.indexOf((this.startDate.getMonth()+1)) + 1)+ '季度没有计划内容'
                    }
                }
                if (p.length > 0) {
                    this.planData = p[0]
                }
                else this.planData =null
            },
            getWeek: function (z) {//参数z是"2018-05-07 15:12:36"或者"2018/05/07 15:12:36"
                let day11 = new Date(z);
                day11.setMonth(0);
                day11.setDate(1);
                day11.setHours(0);
                day11.setMinutes(0);
                day11.setSeconds(0);//到这里就得到该年的一月一日

                let day11mill = day11.getTime();
                let ori_day = day11.getDay();//该年的一月一日是星期几
                let fill1 = 0;//与星期日相隔的毫秒数
                if (ori_day !== 0) {
                    fill1 = ori_day * 60 * 60 * 24 * 1000;
                }

                let now = Date.parse(z);
                now = new Date(now);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                let nowmill = now.getTime();
                let now_day = now.getDay();
                let fill2 = 0;
                if (now_day !== 0) {
                    fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
                }

                let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
                let week = Math.ceil(cha2 / 7);
                if (week < 10) {
                    week = "0" + week;
                }
                return week;
            }
        },
        computed: {
            ...mapState({
                my_plans: state => state.plan.my_plans,
            }),
            ...mapGetters({}),
        },
        watch: {
            startDate: function (value, oldValue) {
               this.getPlanData()
            }
        },
        created: function () {

        },
        mounted() {
            this.startDate = new Date(this.dateValue.toString());
            this.prev();
            if (this.plan_Type == 'week') {
                this.prevText = '上一周'
                this.nextText = '下一周'
            }
            if (this.plan_Type == 'quarter') {
                this.prevText = '上一季度'
                this.nextText = '下一季度'
            }

        }
    }
</script>

<style scoped>
    .preview-detail {
        position: absolute;
        right: 0;
        width: 0;
        bottom: 0;
        top: 50px;
        background-color: #fff;
        border-left: 1px solid #979797;
        border-top: 1px solid #979797;
        box-shadow: -2px 0px 5px 0px rgba(0, 0, 0, 0.16);
        overflow: hidden;
        z-index: 99;
    }

    .preview-detail .preview-bar {
        height: 52px;
        background-color: #fafafa;
        border-bottom: 1px solid #ECEAEB;
    }

    .preview-detail .preview-bar .prev-close {
        height: 28px;
        background-color: #fff;
        border: 1px solid #d7d8d9;
        margin-right: 20px;
        width: 73px;
        margin-top: 12px;
        float: right;
    }

    .preview-detail .preview-bar .prev-button, .preview-detail .preview-bar .next-button {
        height: 28px;
        background-color: #fff;
        border: 1px solid #d7d8d9;
        margin-left: 20px;
        width: 73px;
        margin-top: 12px;
        float: left;
        border-radius: 3px;
    }

    .preview-plan-detail {
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #fff;
        z-index: -1 \0;
        overflow-x: hidden;
        overflow-y: auto;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 53px;
    }

</style>